import { QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { Tooltip } from 'antd';

const TitleTooltip: React.FC<{ title: string; tooltip?: string }> = ({
  title,
  tooltip = '',
}) => {
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    lineHeight: '50px',
  } as React.CSSProperties;

  return (
    <div style={containerStyle}>
      <h2 style={{ margin: 0, marginRight: 4 }}>{title}</h2>
      {tooltip && (
        <Tooltip title={tooltip}>
          <QuestionCircleOutlined style={{ cursor: 'help' }} />
        </Tooltip>
      )}
    </div>
  );
};

export default TitleTooltip;
